document.addEventListener('DOMContentLoaded', function() {
  // Only run on collection pages with the product-grid element
  const productGrid = document.getElementById('product-grid');
  if (!productGrid || !window.location.pathname.includes('/collections/')) return;

  // Get all pagination links (adjust selector if your pagination HTML differs)
  const paginationLinks = document.querySelectorAll('.pagination a');

  paginationLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const url = new URL(this.href);
      const targetPage = url.searchParams.get('page');

      // For page 1, load without hash (scrolls to top)
      if (targetPage === '1' || !targetPage) {
        window.location.href = url.origin + url.pathname + url.search;
        return;
      }

      // For other pages, add #product-grid anchor
      window.location.href = `${url.origin}${url.pathname}${url.search}#product-grid`;
    });
  });
});